module.exports = __webpack_public_path__ + "img/how-to-navigate-4.713cc1f5.jpg";